import { CSS } from '@grupoboticario/flora-react'

export const closeButtonCss: CSS = {
  padding: 0,
  right: '$4',
  top: '$4'
}
